import React, { useState } from 'react';
import { Text, Colors, TextProps } from 'library';
import { Accordion, AccordionDetails, AccordionSummary, Grid, useMediaQuery } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import theme from 'theme';

export default function EldercareWhyTandem() {
    const [expandedSection, setExpandedSection] = useState<string>('');
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    function WhiteText({
        children,
        variant = 'body1',
        bold = false,
        inline = false,
    }: {
        children: React.ReactNode | string;
        variant?: TextProps['variant'];
        bold?: boolean;
        inline?: boolean;
    }) {
        return (
            <Text bold={bold} variant={variant} inline={inline} textStyle={{ color: Colors.white, width: 'unset' }}>
                {children}
            </Text>
        );
    }
    const expandableSections = [
        {
            title: 'Flexibilty',
            text:
                "Set your preferred pay rate for shifts. With Tandem, you're in control, promoting a more flexible and accommodating staffing arrangement.",
            icon: <EventAvailableIcon style={{ color: Colors.white }} />,
        },
        {
            title: 'Transparency',
            text:
                "At Tandem, transparency is paramount. You decide the shift's pay rate, with only a small hourly fee. Plus, after just 120 hours, onboard staff permanently - no extra charges.",
            icon: <ThumbUpIcon style={{ color: Colors.white }} />,
        },
        {
            title: 'Efficiency',
            text:
                "Experience hassle-free staffing solutions. Tandem's platform efficiently matches your facility's needs with credentialed professionals.",
            icon: <AssignmentTurnedInIcon style={{ color: Colors.white }} />,
        },
        {
            title: 'Cost-Effective',
            text:
                "Tandem's small hourly fee and the opportunity for permanent onboarding after 120 hours mean more savings for your facility.",
            icon: <AttachMoneyIcon style={{ color: Colors.white }} />,
        },
        {
            title: 'Quality Care',
            text:
                'Our focus on connecting you with skilled and experienced professionals means you can provide exceptional care and services to your residents.',
            icon: <PlaylistAddCheckIcon style={{ color: Colors.white }} />,
        },
    ];
    return (
        <Grid
            xs={12}
            style={{ gap: 20, backgroundColor: Colors.darkNavy, padding: smDown ? 20 : 50 }}
            direction="row"
            justifyContent="center"
            container
            item
        >
            <Grid
                xs={12}
                lg={6}
                container
                item
                alignItems={'center'}
                justifyContent="center"
                direction="column"
                style={{ gap: 20 }}
            >
                <WhiteText bold variant="display">
                    Why Tandem?
                </WhiteText>
                <WhiteText>
                    Tandem offers{' '}
                    <WhiteText bold inline>
                        {' '}
                        transparent, efficient
                    </WhiteText>{' '}
                    staffing with{' '}
                    <WhiteText bold inline>
                        flexible
                    </WhiteText>{' '}
                    pay rates, focusing on{' '}
                    <WhiteText bold inline>
                        quality care
                    </WhiteText>{' '}
                    by connecting facilites to skilled professionals in the most{' '}
                    <WhiteText bold inline>
                        cost-effective
                    </WhiteText>{' '}
                    way available to you.
                </WhiteText>
            </Grid>

            <Grid xs={12} lg={8} style={{ backgroundColor: Colors.lightTurq }}>
                {expandableSections.map((section, index) => (
                    <Accordion
                        key={index}
                        expanded={expandedSection === section.title}
                        onChange={() => setExpandedSection(expandedSection === section.title ? '' : section.title)}
                        style={{
                            marginBottom: index === expandableSections.length - 1 ? 0 : 10,
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Grid item container direction="row" style={{ gap: 40 }} alignItems="center">
                                <Grid
                                    container
                                    item
                                    alignItems="center"
                                    justifyContent="center"
                                    style={{
                                        borderRadius: 50,
                                        backgroundColor: Colors.mediumTurq,
                                        width: 50,
                                        height: 50,
                                    }}
                                >
                                    {section.icon}
                                </Grid>
                                <Text variant={smDown ? 'body1' : 'display'} bold>
                                    {section.title}
                                </Text>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Text>{section.text}</Text>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Grid>
        </Grid>
    );
}
